// Voice preference storage utilities
const KEY_VOICE = "sereno_voice_uri";
const KEY_RATE = "sereno_voice_rate";

export function getVoiceURI() {
  return typeof window !== "undefined" ? localStorage.getItem(KEY_VOICE) || "" : "";
}
export function setVoiceURI(uri) {
  if (typeof window !== "undefined") localStorage.setItem(KEY_VOICE, uri || "");
}
export function getVoiceRate() {
  if (typeof window === "undefined") return 0.95;
  const v = parseFloat(localStorage.getItem(KEY_RATE) || "0.95");
  return isNaN(v) ? 0.95 : v;
}
export function setVoiceRate(rate) {
  if (typeof window !== "undefined") localStorage.setItem(KEY_RATE, String(rate));
}

export function loadVoices() {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return [];
  return window.speechSynthesis.getVoices();
}

// Return voices that best match the given lang code ("fr" or "en")
export function voicesForLang(lang) {
  return loadVoices().filter(
    (v) => v.lang && v.lang.toLowerCase().startsWith(lang.toLowerCase())
  );
}

// Detect "best" (high-quality / neural / natural) voices
// so we can mark them with a star in the picker.
// Local / native-quality voices (Apple, Microsoft, Google) generally sound the most natural.
const PREMIUM_HINTS = [
  "neural",
  "premium",
  "enhanced",
  "natural",
  "wavenet",
  "studio",
  "online",
  "google",
  "microsoft",
  "eloquence",
  // Apple / macOS / iOS premium French voices
  "amélie",
  "amelie",
  "thomas",
  "audrey",
  "aurélie",
  "aurelie",
  // Apple / macOS / iOS premium English voices
  "samantha",
  "alex",
  "ava",
  "serena",
  "moira",
];
export function isBestVoice(voice) {
  if (!voice || !voice.name) return false;
  const n = voice.name.toLowerCase();
  return PREMIUM_HINTS.some((hint) => n.includes(hint));
}

export function pickVoice(lang) {
  const uri = getVoiceURI();
  const list = voicesForLang(lang);
  if (uri) {
    const found = list.find((v) => v.voiceURI === uri);
    if (found) return found;
  }
  return list[0] || null;
}

export function speak(text, lang) {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return null;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = lang === "fr" ? "fr-FR" : "en-US";
  utter.rate = getVoiceRate();
  utter.pitch = 1;
  const v = pickVoice(lang);
  if (v) utter.voice = v;
  window.speechSynthesis.speak(utter);
  return utter;
}

export function stopSpeaking() {
  if (typeof window !== "undefined" && "speechSynthesis" in window) {
    window.speechSynthesis.cancel();
  }
}
